<template>
    <Dialog :header="messageTitle" v-model:visible="this.announcementDialog" class="message-dialog" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" :modal="true" :closeOnEscape="false" :closable="false" >
        <div class="announcement-scroll-wrapper">
            <div ref="scrollContent" class="announcement-content" @scroll="onScroll">
                <span style="white-space: pre-line;" v-html="setupMessage"></span>
            </div>
            <div v-if="showScrollHint" class="scroll-hint">
                <i class="pi pi-chevron-down scroll-hint-icon"></i>
            </div>
        </div>
        <template #footer>
            <Button label="Entendido" @click="messageRead" class="p-button-raised p-button-info mr-2 mb-2" />
        </template>
    </Dialog>
</template>

<script>
    export default {
        props: {
            message: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                announcementDialog: false,
                showScrollHint: false,
            }
        },
        watch: {
            message(val) {
                this.announcementDialog = !!(val && val.id);
                if (this.announcementDialog) {
                    this.$nextTick(function() {
                        this.checkScrollable();
                    });
                }
            }
        },
        computed: {
            setupMessage() {
                return this.message ? this.message.body : '';
            },
            messageTitle() {
                return this.message ? this.message.title : '';
            },
        },
        methods: {
            messageRead() {
                if (this.message && this.message.id) {
                    this.$emit('message-read', this.message.id);
                }
                this.announcementDialog = false;
            },
            checkScrollable() {
                var el = this.$refs.scrollContent;
                if (el) {
                    this.showScrollHint = el.scrollHeight > el.clientHeight;
                }
            },
            onScroll() {
                var el = this.$refs.scrollContent;
                if (el) {
                    var atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 10;
                    this.showScrollHint = !atBottom;
                }
            },
        },
    }
</script>
<style scoped lang="scss">
    .announcement-scroll-wrapper {
        position: relative;
    }
    .announcement-content {
        max-height: 55vh;
        overflow-y: auto;
        padding: 0 0.5rem;
        scroll-behavior: smooth;
    }
    .scroll-hint {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 60px;
        background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.95) 100%);
        display: flex;
        align-items: flex-end;
        justify-content: center;
        pointer-events: none;
    }
    .scroll-hint-icon {
        font-size: 1.2rem;
        color: #6b7280;
        animation: bounceDown 1.5s infinite;
        margin-bottom: 4px;
    }
    @keyframes bounceDown {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(6px); }
    }
    @media screen and (max-width: 769px) {
        .message-dialog {
            min-width: 200px;
            max-width: 90%;
        }
        .announcement-content {
            max-height: 45vh;
        }
    }
    @media screen and (min-width: 769px) {
        .message-dialog {
            min-width: 350px;
            max-width: 500px;
        }
    }
</style>